// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.00094 0.213867L12.001 13.2139L17.001 0.213867L23.457 17.0001L18.001 16.9998V22H16.001V16.9997H8.00096V22H6.00096V16.9998L0.544922 17.0001L7.00094 0.213867Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-forest-filled')
export default class ForestFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'forest-filled',
    }
  }
}
